<script lang="ts">
  import { tweened } from "svelte/motion";

  export let open = false;

  const tween = tweened(1, {
    duration: 200,
  });

  $: if (open) {
    tween.set(0);
    document.body.classList.add("modal-open");
  } else {
    tween.set(1);
    document.body.classList.remove("modal-open");
  }
</script>

<div
  class="overlay"
  on:click={() => (open = false)}
  style={`opacity:${1 - $tween};visibility:${
    1 - $tween <= 0 ? "hidden" : "visible"
  }`}></div>
<div
  class="modal"
  style={`transform:translateY(${$tween * 100}%);visibility:${
    1 - $tween <= 0 ? "hidden" : "visible"
  };`}
>
  <slot/>
</div>

<style lang="scss">
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    z-index: 50;
  }

  .modal {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 0 -4px 26px rgba(0, 0, 0, 0.4);
    position: fixed;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    -ms-overflow-y: auto;
    width: 100%;
    max-height: 90%;
    padding-bottom: env(safe-area-inset-bottom, 15px);
    min-height: 120px;
    background: #fff;
    transition: all 0.3s;
    z-index: 50;
  }
</style>
